export default __webpack_public_path__ + "static/media/DC_Icon.9220d649.svg";